import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { ContactDealer } from '@volkswagen-onehub/icons-core';

import React from 'react';
import { highlightMatch } from '../../../helpers/highlight-match-helpers';
import { NdpsDealer } from '../../../types/dealer-types';
import { OptionCard } from './core/option-card';

interface Props {
	dealer: NdpsDealer;
	isActive?: boolean;
	hasError?: boolean;
	showDetails?: boolean;
	highlight?: string;
	onSelect?: () => void;
}

export function DealerOptionCard(props: Props) {
	const { dealer, isActive = false, hasError = false, showDetails = false, highlight, onSelect } = props;
	const query = isActive ? undefined : highlight;

	return (
		<OptionCard
			icon={<ContactDealer />}
			isActive={isActive}
			hasError={hasError}
			onSelect={onSelect}
			dataAttributes={{
				'data-id': dealer.Id,
				'data-kvps': dealer.KVPSCode__c,
				'data-code': dealer.VGED_DealerCode__c,
				'data-concession': dealer.VGED_ConcessionDealerCode__c,
				'data-type': dealer.RCY_DealerType__c,
			}}
			title={highlightMatch(dealer.VGED_CommercialName__c, query)}
			index={dealer.Distance ? `${dealer.Distance.toFixed(1)} km` : ''}
		>
			<Text appearance={TokenTextAppearance.copy100}>
				{showDetails && (
					<Text appearance={TokenTextAppearance.copy100}>
						{highlightMatch(dealer.KVPSCode__c, query)} {highlightMatch(dealer.VGED_DealerCode__c, query)}{' '}
						{highlightMatch(dealer.VGED_ConcessionDealerCode__c, query)}
						<br />
					</Text>
				)}
				{highlightMatch(dealer.ShippingStreet, query)}, {highlightMatch(dealer.ShippingPostalCode, query)}{' '}
				{highlightMatch(dealer.ShippingCity, query)}
			</Text>
		</OptionCard>
	);
}
